import { Button, InformationBox } from '@pukka/ui-components';
import { BillingRecurringReminder } from '@pukka/ui-composite';
import DOMPurify from 'dompurify';
import { marked } from 'marked';
import { useSnapshot } from 'valtio';

import { BillingPersistedState, BillingState } from '../Billing.state';
import { BillingHistory } from '../BillingHistory';

import { BillingPaymentMethod } from './BillingPaymentMethod';
import { BillingPriceBreakdownModal } from './BillingPriceBreakdownModal';
import { BillingSummary } from './BillingSummary';
import { ModifyBillingModal } from './ModifyBillingModal';
import { RecurringPaymentState } from './RecurringPayment.state';

function getUnsafeHTMLContent(content: string) {
  const markdown = DOMPurify.sanitize(marked.parse(content) as string);

  return { __html: markdown };
}

function RecurringPaymentTab() {
  const { recurring, histories, profile } = useSnapshot(BillingPersistedState);
  const { isRecurringFetching } = useSnapshot(BillingState);
  const { isLoadingManageCard, isPriceBreakdownModalShown, isModifyBillingModalShown } = useSnapshot(RecurringPaymentState);
  const { onManageCard, onTogglePriceBreakdownModal, onToggleModifyBillingModal } = RecurringPaymentState;

  return (
    <div className="flex flex-col gap-10">
      {recurring?.errorMessage && (
        <InformationBox variant="danger" icon title="Pembayaran gagal">
          <div dangerouslySetInnerHTML={getUnsafeHTMLContent(recurring.errorMessage)} data-testid="error-message" />
          {/* eslint-disable-next-line react/jsx-no-bind */}
          <Button variant="danger" className="float-right" onClick={onManageCard.bind({}, undefined)}>
            Update now
          </Button>
        </InformationBox>
      )}

      {!isRecurringFetching && profile?.isOwner && <BillingRecurringReminder />}

      <div className="flex flex-col gap-5 md:flex-row">
        <BillingSummary
          loading={isRecurringFetching}
          packageName={recurring?.plan ?? ''}
          description={recurring?.description}
          planName={recurring?.interval}
          originalPrice={recurring?.prices?.total.originalPrice}
          finalPrice={recurring?.prices?.total.finalPrice}
          nextBillingDate={recurring?.nextBillingDate}
          outletCount={recurring?.outletCount}
          employeeSlotCount={recurring?.employeeSlotCount}
          hideBillingDate={profile?.hasExpired}
          onClickSeeDetail={onTogglePriceBreakdownModal}
          onClickModifyBilling={onToggleModifyBillingModal}
        />
        <BillingPaymentMethod
          loading={isRecurringFetching}
          title={recurring?.payment?.title}
          caption={recurring?.payment.caption}
          information={recurring?.payment?.cardBillingTo}
          imageUrl={recurring?.payment?.cardImageUrl}
          buttonText={profile?.hasExpired ? 'Renew Subscription' : 'Manage Card'}
          buttonLoading={isLoadingManageCard}
          // eslint-disable-next-line react/jsx-no-bind
          onClick={onManageCard.bind({}, undefined)}
        />
      </div>
      <BillingPriceBreakdownModal open={isPriceBreakdownModalShown} onToggleModal={onTogglePriceBreakdownModal} />
      <ModifyBillingModal open={isModifyBillingModalShown} onToggleModal={onToggleModifyBillingModal} />

      <BillingHistory data={histories} />
    </div>
  );
}

export { RecurringPaymentTab };
